import Litepicker from 'litepicker';

export default bookOffer => {
    // console.log('bookOffer');
    const headerHeight = document.querySelector('header').offsetHeight;
    //const navHeight = document.querySelector('.section.hero-top').offsetHeight;
    const bookOfferForm = bookOffer.querySelector('form');
    const inputDate = bookOffer.querySelector('#input-date');
    const btnBook = bookOffer.querySelector('#book-offer-btn');

    // window.addEventListener('load', () => {
    //     const litepicker = document.querySelector('.litepicker');
    // }, false);

    if(inputDate != null){


      let params = {
          element: inputDate,
          firstDay: 1,
          format: 'DD/MM/YYYY',
          bookedDaysFormat: 'DD/MM/YYYY',
          lang: 'fr-FR',
          numberOfMonths: 2,
          numberOfColumns: 2,
          singleMode: false,
          autoApply: true,
          showTooltip: false,
          parentEl: inputDate.parentNode,
          // autoApply: false,
          onShow: function(){
              // Calculate if Calendar needs to be shown above the Date field
              let picker = document.querySelector('.litepicker');
              let bounds = picker.getBoundingClientRect();
              let vh = window.innerHeight;

              if( vh < bounds.bottom ){
                  document.querySelector('.litepicker').classList.add('above');
              }
          },
          onHide: function(){
              // Remove 'Above' class
              document.querySelector('.litepicker').classList.remove('above');
          }
      };

      if(inputDate.dataset.mindate != "" && inputDate.dataset.mindate != undefined){
        let dateminArray = inputDate.dataset.mindate.split('/');
        params.minDate = new Date(dateminArray[2], dateminArray[1] - 1, dateminArray[0]);
      }
      if(inputDate.dataset.maxdate != "" && inputDate.dataset.maxdate != undefined){
        let datemaxArray = inputDate.dataset.maxdate.split('/');
        params.maxDate = new Date(datemaxArray[2], datemaxArray[1] - 1, datemaxArray[0]);
      }
      const datePicker = new Litepicker(params);



      btnBook.addEventListener('click', event => {
          if (inputDate.value !== '') {
              inputDate.parentNode.classList.remove('error');
              //bookOfferForm.submit();
          } else {
              event.preventDefault();
              inputDate.parentNode.classList.add('error');
          }
      });
    }

    resizeBook();
    window.onresize = resizeBook;

    function resizeBook(){
        let ww = window.innerWidth;
        let topBlocPosition = headerHeight + 230;
        let topBlocOffset = bookOffer.offsetHeight / 2;
        let heroBloc = document.querySelector('.hero');
        let heroBlocBottomOffset = heroBloc.getBoundingClientRect().bottom;

        if( ww >= 992 ){
            if(window.innerHeight < topBlocPosition + bookOffer.offsetHeight){
                topBlocPosition = window.innerHeight - bookOffer.offsetHeight - 30;
             } else {
                topBlocPosition = headerHeight + 230;
             }
              bookOffer.style.top = `${topBlocPosition}px`;
        } else {
            bookOffer.style.top = `auto`;
        }
    }

};
